function first<T extends HTMLElement | SVGElement = HTMLElement>(selector: string, root?: Element) : T {
    const foundElement = (root || document).querySelector<T>(selector);
    if (!foundElement) {
        throw new Error(`element '${selector}' was not found.`);
    } else {
        return foundElement as T;
    }
}

function tryFirst<T extends HTMLElement | SVGElement>(selector: string, root?: Element): T | null {
    const foundElement = (root || document).querySelector<T>(selector);
    if (!foundElement) {
        console.warn(`element '${selector}' was not found.`);
    }
    return foundElement;
}

function all<T extends HTMLElement | SVGElement>(selector: string, root?: Element): Array<T> {
    return Array.from((root || document).querySelectorAll<T>(selector));
}


const isProduction = () => {
    const url = window.location.href;
    if (url.indexOf('localhost') === -1) {
        return false;
    }
    return true;
}

const getAntiforgeryToken = (form: HTMLFormElement) => {
    const input = form.getElementsByTagName('input');
    for (let i = 0; i < input.length; i++) {
        if (input[i].name === '__RequestVerificationToken') {
            return {
                key: '__RequestVerificationToken',
                value: input[i].value
            }
        }
    }
}


export {
    first,
    tryFirst,
    all,
    isProduction,
    getAntiforgeryToken
}